
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auto-parts/[category]/[subCategory]",
      function () {
        return require("private-next-pages/auto-parts/[category]/[subCategory]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auto-parts/[category]/[subCategory]"])
      });
    }
  